import { render } from "./BurndownChart.vue?vue&type=template&id=d55f0278&scoped=true"
import script from "./BurndownChart.vue?vue&type=script&lang=js"
export * from "./BurndownChart.vue?vue&type=script&lang=js"

import "./BurndownChart.vue?vue&type=style&index=0&id=d55f0278&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d55f0278"]])

export default __exports__